import React, { useState, useRef, useEffect } from 'react'
import LoadingOverlay from "components/loadingOverlay";

import TestDrawingBoard from './TestDrawingBoard'

const buttonStyling = `
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font: 400 13.3333px Arial;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  margin-left: 10px
`

const SignConfirmationForm = ( props ) => {

  const iframeRef = useRef( null );
  const filePond = useRef( null );
  const [ showSignBox, updateShowSignBox ] = useState( false )
  const [ onLoad, setLoading ] = useState( true )

  useEffect(() => {
    if ( props.scrollToBottom ) {
      let tempContentWindow = iframeRef.current.contentWindow
      let element = tempContentWindow.document.getElementById( 'acknowledge_inventory_checklist' )
      element?.scrollIntoView({ block: 'start',  behavior: 'smooth' })
      
      let checkboxElement = tempContentWindow.document.getElementById( 'acknowledge_inventory_checklist' )
      checkboxElement.style.boxShadow = '0px 0px 8px 2px #F04438'
      checkboxElement.style.backgroundColor = '#F04438'
      props.onChangeScrollToBottom(false)
    }
  }, [ props.scrollToBottom ])

  const editIframeContent = () => {
    let triggerSignButton = document.createElement( "button" )
    let triggerStampButton = document.createElement( "button" )
    triggerSignButton.onclick = () => updateShowSignBox( true )
    triggerSignButton.innerHTML = 'Click here to sign'
    triggerSignButton.style.cssText= buttonStyling
    
    if( props.signee_type_id === 1 ){
      triggerStampButton.onclick = () => filePond.current.click()
      triggerStampButton.innerHTML = 'Attach company stamp'
      triggerStampButton.style.cssText= buttonStyling
    }
    
    let tempContentWindow = iframeRef.current.contentWindow
    if ( tempContentWindow.document.body.innerHTML.length > 0 ) {
      let signElement = tempContentWindow.document.getElementById( props.htmlDivId )
      let checkboxElement = tempContentWindow.document.getElementById( 'acknowledge_inventory_checklist' )
      
      signElement.removeChild( signElement.childNodes[ 0 ] )
      signElement.appendChild( triggerSignButton )
      if( [ 1, 3, 4 ].includes( props.formType ) ){
        let stampElement = tempContentWindow.document.getElementById( props.compDivId )
        
        if( props.signee_type_id === 1 ){
          stampElement.removeChild( stampElement.childNodes[ 0 ] )
          stampElement.appendChild( triggerStampButton )
        }
      }
      if (checkboxElement) {
        props.updateAcknowledgeCheckbox( true )
        checkboxElement.onclick = () => {
          checkboxElement.style.boxShadow = 'none'
          checkboxElement.style.backgroundColor = 'transparent'
          props.updateChecked( checkboxElement.checked )
        }
      }

      setLoading( false )
    }
  }

  const onChange = fileItems => {
    if ( fileItems ){
      Object.keys( fileItems ).map( key => {
        let reader = new FileReader()
        reader.onload = e => {
          let temp = e.target.result
          let tempFilename = fileItems[ key ].name
          let tempContentWindow = iframeRef.current.contentWindow
          let stampElement = tempContentWindow.document.getElementById( props.compDivId )
          let stampImage = null

          if( stampElement.getElementsByTagName( 'img' ).length > 0 ){
            stampImage = stampElement.getElementsByTagName( 'img' )[ 0 ]
          } else {
            stampImage = document.createElement( 'img' )
          }

          stampImage.src = e.target.result
          stampImage.style = "width: 150px;"

          let tempButton = stampElement.getElementsByTagName( 'button' )[ 0 ]
          stampElement.appendChild( stampImage )
          stampElement.appendChild( tempButton )

          props.onChangeCompanyStampFilename( tempFilename )
          return props.onChangeCompanyStamp( temp )
        } 
        reader.readAsDataURL( fileItems[ key ] )
      })
    } else {
      return props.onChangeCompanyStamp( null )
    }
  }
  
  return (
    <>
      <iframe 
        className={ 'form-content' }
        ref={ iframeRef }
        srcDoc={ props.content }  
        onLoad={ () => editIframeContent() }/>
      <TestDrawingBoard
        open={ showSignBox }
        formType={ props.formType }
        updateShowSignBox={ updateShowSignBox }
        signedImage={ val => {
          updateShowSignBox( false )
          let tempContentWindow = iframeRef.current.contentWindow
          let element = tempContentWindow.document.getElementById( props.htmlDivId )

          let signImage = document.createElement( 'img' )
          signImage.src = val
          signImage.style = "width: 150px;"

          let tempButton = element.getElementsByTagName( 'button' )[ 0 ]
          element.innerHTML = ''
          element.appendChild( signImage )
          element.appendChild( tempButton )
          props.onChangeSignature( val )
        }}/>
      <input 
        style={{ display: 'none' }} 
        type="file"
        ref={ filePond }
        accept="image/*"
        onChange={ e => onChange( e.target.files ) }
      />
      { onLoad && <LoadingOverlay /> }
    </>
  )
}

export default SignConfirmationForm